module.exports = __webpack_public_path__ + "img/九州机构通客户操作手册6829.40bea10a.png";